import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import QuotePage from './pages/QuotePage';
import './App.css';
import './Animations.css'

function App() {
    return (
        <div className="App">
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/quote" element={<QuotePage />} />
                </Routes>
            </Layout>
        </div>
    );
}

export default App;
